import React from 'react';
import { Loading } from './components/common/loading/loading';

export const wrapRootElement = ({ element }) => <Loading>{element}</Loading>;
